/*
 * @Author: hongye
 * @Description:
 */
const { VUE_APP_GATEWAY, VUE_APP_API_URL_GW } = process.env;
// 后端接口返回的状态码常量
export const RESPONSE_CODE = {
  SUCCESS: 1, // 成功
  SUCCESS_COPY: 1, // 成功 临时使用
  EXPIRED: '000002' // token过期
}
// 网关标识
export const GATEWAY = VUE_APP_GATEWAY || ""
//  公共请求
export const GW_URL = VUE_APP_API_URL_GW || ''
